import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-wrap: nowrap;
`;

export const PriceBlock = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Price = styled.h1`
    ${({ theme }) => theme.typography.Headline};
`;

export const PricePeriod = styled.p`
    ${(props) => props.theme.typography.TinyParagraph};
    align-self: flex-end;
`;

export const Profits = styled.ul`
    list-style: disc;
    margin-left: 32px;
`;

export const Profit = styled.li`
    color: ${({ theme }) => theme.colors['Level 4']};
`;

export const Text = styled.span`
    ${(props) => props.theme.typography.TinyParagraph};
    position: relative;
    left: -4px;
`;
